import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineExclamationOctagonIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 7a1 1 0 0 0-1 1v4a1.0001 1.0001 0 0 0 2 0V8a1.0002 1.0002 0 0 0-1-1Zm0 8a1 1 0 1 0-.0002 2A1 1 0 0 0 12 15Zm9.71-7.44-5.27-5.27a1.0499 1.0499 0 0 0-.71-.29H8.27a1.05 1.05 0 0 0-.71.29L2.29 7.56a1.05 1.05 0 0 0-.29.71v7.46c.0037.2648.1073.5184.29.71l5.27 5.27c.1916.1827.4452.2863.71.29h7.46a1.0501 1.0501 0 0 0 .71-.29l5.27-5.27a1.0501 1.0501 0 0 0 .29-.71V8.27a1.0502 1.0502 0 0 0-.29-.71ZM20 15.31 15.31 20H8.69L4 15.31V8.69L8.69 4h6.62L20 8.69v6.62Z"/>
  </SvgIcon>
}

export default LineExclamationOctagonIcon
